export default "__VITE_ASSET__33acea21__"